import store from "@/store/store";
import BeCuponUtils from "@/utils/Utils";

export default class Raffles {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query{
          rafflesRetrieve(id:${id}){
              id
              name
              description
              dateResult
              cantWin
              coupon {
                id
                title
              }
          }
        }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    if(BeCuponUtils.isManager(store.state.currentUser) !== -1 || !BeCuponUtils.isAdmin(store.state.currentUser)) {
       if(response.data.data.rafflesRetrieve.coupon !== null) response.data.data.rafflesRetrieve.coupon.maximumSales = "N/A";
    }

    response.data.data.rafflesRetrieve.compressed = {
      coupon: response.data.data.rafflesRetrieve.coupon,
      name: response.data.data.rafflesRetrieve.name,
      type: response.data.data.rafflesRetrieve.description,
      cantWin: response.data.data.rafflesRetrieve.cantWin,
      dateResult: response.data.data.rafflesRetrieve.dateResult
    };
    response.data.data.rafflesRetrieve.coupon = response.data.data.rafflesRetrieve.coupon.id;
    return response.data.data.rafflesRetrieve;
  }

  static async all(payload) {
    const response = await payload.axios.post(
      '/graphql/',
      `query{
        rafflesList{
          results{
              id
              name
              description
              dateResult
              cantWin
              coupon {
                id
                title
              }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return response.data.data.rafflesList.results.reverse();
  }

  // static async filter(axios, active) {
  //   const response = await axios.post(
  //     '/graphql/',
  //     `query{
  //       couponList (active: ${active}){
  //         results{
  //           id
  //           isActive
  //           available
  //           amountCompleted
  //           amountActives
  //           title
  //           expirationDate
  //           globalTotalUses
  //           globalUses
  //           inWallet
  //           globalActives
  //           images {
  //             id
  //             url
  //           }
  //           initialDate
  //           dailyUses
  //           totalUses
  //           showApp
  //           assignedCoupon
  //           qrText
  //           company{
  //             id
  //             name
  //           }
  //           qrValidationCode
  //           qrValidationCodeUses
  //           totalClick
  //           qrBarcode {
  //             id
  //             url
  //           }
  //           coupons{
  //             id
  //             title
  //           }
  //           branchOffices{
  //             id
  //             name
  //           }
  //           couponsUses{
  //             id
  //           }
  //         }
  //       }
  //     }`,
  //     {
  //       headers: {
  //         'Content-Type': 'application/graphql'
  //       }
  //     }
  //   );
  //
  //   return response.data.data.couponList.results.reverse();
  // }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/', {
        query: `mutation deletePromotion ($id: ID!){
          deletePromotion(id: $id){
            ok
          }
        }`,
        variables: {
          "id": id
        }
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data.data.deletePromotion.ok;
  }
}
